import { render } from "./ChaneZani.vue?vue&type=template&id=af5a3136&scoped=true"
import script from "./ChaneZani.vue?vue&type=script&lang=js"
export * from "./ChaneZani.vue?vue&type=script&lang=js"

import "./ChaneZani.vue?vue&type=style&index=0&id=af5a3136&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5a3136"]])

export default __exports__